<template>
    <div id="SMFConsulting">
        <div class="container">
            <h1 class="text-secondary">{{ $t('consulting') }}</h1>
            <webRequest :url="getUrl" :key="componentKey" ident="productConsulting"></webRequest>
        </div>
    </div>
</template>

<script>
    import webRequest from '@/components/web-request.vue'

    export default {
        name: 'Consulting',
        components: {
            webRequest
        },
        data() {
            return {
                data: 'loading...',
                componentKey: 0
            }
        },
        methods: {
            refreshComponent() {
                this.componentKey += 1
            }
        },
        computed: {
            getUrl() {
                return '/consulting-' + this.$i18n.locale + '.html'
            }
        }
    }
</script>

<style scoped lang="css">
    figure {
        margin: 2%;
    }

    aside {
        float: right;
        width: 20%;
        text-align: center;
    }
</style>

<style scoped>
    .docscript-img {
        max-width: 95%;
        border: 2px solid #777;
    }

        .docscript-img:hover {
            box-shadow: 0 0 10px #ccc;
        }

    .docscript-footnote {
        margin-bottom: 0rem;
    }

    #SMFConsulting {
        background: rgb(220,226,226);
        /* background: linear-gradient(13deg, rgba(220,226,226,1) 0%, rgba(50,94,143,1) 83%, rgba(44,83,138,1) 100%); */
    }
</style>
